import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeLeft',
  pure: false // This ensures the pipe is re-evaluated every time change detection runs
})
export class TimeLeftPipe implements PipeTransform {

  transform(value: number): string {
    if (!value) return '';

    const now = new Date().getTime();
    const timeDiff = value - now;

    if (timeDiff <= 0) {
      return 'Fecha superada';
    }

    const seconds = Math.floor((timeDiff / 1000) % 60);
    const minutes = Math.floor((timeDiff / 1000 / 60) % 60);
    const hours = Math.floor((timeDiff / (1000 * 60 * 60)) % 24);
    const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));

    if (days > 0) {
      return `${days} día${days > 1 ? 's' : ''} faltan`;
    } else if (hours > 0) {
      return `${hours} hora${hours > 1 ? 's' : ''} faltan`;
    } else if (minutes > 0) {
      return `${minutes} minuto${minutes > 1 ? 's' : ''} faltan`;
    } else {
      return `${seconds} segundo${seconds > 1 ? 's' : ''} faltan`;
    }
  }
}

